'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxForm = require('redux-form');

var _FormField = require('./FormField');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FieldLabel = function FieldLabel(props, context) {
  var field = (0, _FormField.getField)(context.fields, props.name || context.name, context.namePrefix) || {};
  var DisplayLabel = props.renderLabel || props.render || context.renderLabel(props.type || field.labelType || props.labelType || field.type || 'text');
  return _react2.default.createElement(DisplayLabel, _extends({}, props, { field: field }));
};

FieldLabel.propTypes = {
  renderLabel: _propTypes2.default.func,
  render: _propTypes2.default.func,
  labelType: _propTypes2.default.string,
  name: _propTypes2.default.string
};

FieldLabel.defaultProps = {
  renderLabel: null,
  render: null,
  labelType: null,
  name: null
};

FieldLabel.contextTypes = {
  fields: _propTypes2.default.object,
  name: _propTypes2.default.string,
  renderLabel: _propTypes2.default.func,
  namePrefix: _propTypes2.default.string
};

exports.default = FieldLabel;